import {extend} from "vee-validate";
import {email, required, numeric, max, max_value, min, min_value} from "vee-validate/dist/rules";

import parsePhoneNumber from "libphonenumber-js";


const PASSWORD_REGEX = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");

extend("email", {
    ...email,
    message: "Must be a valid email address."
});

extend("required", {
    ...required,
    message: "This field is required."
});

extend("numeric", {
    ...numeric,
    message: "The {_field_} must be a valid number."
});

extend("max", {
    ...max,
    message: "The {_field_} must be less than {length} character(s)."
});

extend("max_value", {
    ...max_value,
    message: "The {_field_} must be less than {max}."
});

extend("min", {
    ...min,
    message: "The {_field_} must be at least {length} character(s)."
});

extend("min_value", {
    ...min_value,
    message: "The {_field_} must be greater than {min}."
});

extend("password", {
    message: "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character",
    validate: value => PASSWORD_REGEX.test(value)
});

extend("phone", {
    message: "Not a valid phone number.",
    validate: value => {
        const number = parsePhoneNumber(value);

        if (!number) {
            return false;
        }

        return number.isValid();
    }
});

extend("decimal", {
    validate: (value, {digits = "16", decimals = "3", separator = "."} = {}) => {
        if (value === null || value === undefined || value === "") {
            return {
                valid: false
            };
        }

        if (Number(decimals) === 0) {
            return {
                valid: /^-?\d*$/.test(value)
            };
        }

        const regexPart = decimals === "*" ? "+" : `{1,${decimals}}`;
        const regex = new RegExp(`^[-+]?\\d{1,${digits}}(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

        return {
            valid: regex.test(value)
        };
    },
    message: "The {_field_} must be a valid number."
});
